import ERROR_MESSAGES from "@/utils/errors/errorMessages";
import { config } from "@/config";
import axios from "axios";
import { AppError } from "@utils/errors/appError";

export const apiGuestClient = axios.create({
  baseURL: config.site.apiUrl,
});

apiGuestClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.data?.message) {
      const errorMessage = error.response.data.message;
      const translatedMessage =
        ERROR_MESSAGES[errorMessage] ||
        "Erro desconhecido. Tente novamente mais tarde.";
      return Promise.reject(new AppError(translatedMessage));
    }

    return Promise.reject(
      new AppError("Erro no servidor. Tente novamente mais tarde!"),
    );
  },
);
